import React from 'react'

const Loader = () => {
  return (
    <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
      <img
        src={`${process.env.PUBLIC_URL}/assets/Loading.svg`}
        alt="Loading"
        className='main-loader'
        style={{ width: '100px' }}
      />
    </div>

    // <div  className='d-flex  justify-content-center align-items-center' style={{height:'100vh'}}>
    //     <img src="nesmaOld/assets/Loading.svg" alt="Loading" className='main-loader' style={{width:'100px'}}/> 
    // </div>
  )
}

export default Loader